import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Tools|Audit Queue|Stats';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'SP',
};

type SPAuditQueueStatsLoc =
	| 'SPAuditQueueStatsTitle'
	| 'SpAuditQueueStatsHistory'
	| 'SPAuditQueueStatsUnassigned'
	| 'SPAuditQueueStatsPastDue'
	| 'SPAuditQueueStatsInProgress'
	| 'SPAuditQueueStatsOnHold'
	| 'SPAuditQueueStatsNewAudits'
	| 'SPAuditQueueStatsYearToDate'
	| 'SPAuditQueueStatsDownload';

export const spAuditQueueStatsLocs: LocDefs<SPAuditQueueStatsLoc> = {
	SPAuditQueueStatsTitle: {
		defaultValue: 'Audit Stats',
		description: 'Page title and heading for the candidate history audit page.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SpAuditQueueStatsHistory: {
		defaultValue: 'Audit History',
		description: 'Page title and heading for the candidate history audit page.',
		displayPath: `${dpRoot}|History`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueStatsUnassigned: {
		defaultValue: 'Unassigned',
		description: 'Title for unassigned audit status.',
		displayPath: `${dpRoot}|Unassigned`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueStatsPastDue: {
		defaultValue: 'Past Due',
		description: 'Title for past due audit status.',
		displayPath: `${dpRoot}|Past Due`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueStatsInProgress: {
		defaultValue: 'In Progress',
		description: 'Title for in progress audit status.',
		displayPath: `${dpRoot}|In Progress`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueStatsOnHold: {
		defaultValue: 'On Hold',
		description: 'Title for on hold audit status.',
		displayPath: `${dpRoot}|On Hold`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueStatsNewAudits: {
		defaultValue: 'New Audits',
		description: 'Title for new audits section.',
		displayPath: `${dpRoot}|New Audits`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueStatsYearToDate: {
		defaultValue: 'Year to Date',
		description: 'Title for year to date section.',
		displayPath: `${dpRoot}|Year to Date`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueStatsDownload: {
		defaultValue: 'Download existing file',
		description: 'Button to download completed audits.',
		displayPath: `${dpRoot}|Download`,
		displayType: 'Button',
		...sharedProps,
	},
};

export const spAuditQueueStatsLocKeys = MapLocKeys<SPAuditQueueStatsLoc>(spAuditQueueStatsLocs);
export type SPAuditQueueStatsLocKeys = typeof spAuditQueueStatsLocKeys;
